/* FENN fix: always use the hamburger + slide-out drawer menu ("drawer" style), never
 * the theme's built-in horizontal inline menu ("menu" style) — at every screen width,
 * desktop included.
 *
 * Why: the theme's inline-menu mode (header-component[data-menu-style="menu"]) turned
 * out to have several compounding bugs in this store's compiled CSS bundle:
 *   1. The inline menu was hidden by an unconditional `!important` rule that always
 *      won over the rule meant to show it on desktop, so it silently never appeared.
 *   2. After patching that, the hamburger button — which has its own always-visible
 *      `!important` rule — stayed on screen right next to the now-visible inline menu,
 *      still clickable but leading nowhere useful.
 *   3. After hiding the (redundant) hamburger too, the inline menu itself didn't have
 *      room for every item at real desktop widths and silently collapsed to a bare
 *      "Mais" (overflow) button whose own dropdown never opens.
 * Rather than keep patching each newly-exposed layer of that mode, this store simply
 * never uses it: the hamburger + drawer is the one menu style already confirmed to
 * work correctly (it's what mobile has always used), so we force it everywhere.
 */
(function () {
  function forceDrawerMode() {
    var header = document.querySelector('#header-component');
    if (header && header.dataset.menuStyle !== 'drawer') {
      header.dataset.menuStyle = 'drawer';
    }
  }

  forceDrawerMode();

  // layout/theme.liquid's inline setHeaderMenuStyle() runs once on load, and
  // assets/header.js re-runs the equivalent logic on resize and whenever the
  // (now permanently hidden) inline menu's own overflow-fit calculation changes.
  // Watching the attribute directly — rather than only running once — means any of
  // those recalculations flipping it back to "menu" gets corrected immediately.
  var header = document.querySelector('#header-component');
  if (header) {
    new MutationObserver(forceDrawerMode).observe(header, {
      attributes: true,
      attributeFilter: ['data-menu-style'],
    });
  }
})();
